import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import React, {Component} from 'react';
import {connect} from 'react-redux';
import BlockedDimeCardList from '../components/BlockedDimeCardList';
import PinterestSearchBox from '../components/PinterestSearchBox';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { FaSignOutAlt, FaUser, FaUsers, FaHome, FaPlus, FaFlag } from "react-icons/fa";
import {setSearchField, requestRobots } from '../actions';
import { getSecureItem } from '../utils/encryption';
import env from "react-dotenv";

let BLOCKED_DIMES_URL = `${env.API_URL}/p10/blockedDimes`;

const mapStateToProps = state => {
  return{
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    ispending: state.requestRobots.ispending,
    error: state.requestRobots.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots())
  }
}

class ReportedDime extends Component{
  constructor() {
    super();
    this.state = {
      route: 'signin',
      isSignedIn: false,
      isLoading: true,
      error: null,
      userId: '',
      userDataReady: false,
      dime: {
        dime_id: '',
        user_id: '',
        rating_count: '',
        category: '',
        image_key: '',
        rating: ''
      },
      robots: [],
      searchfield: ''
    }
    this.setStateApp = this.setStateApp.bind(this);
    this.loadUserIdSync();
  }

  loadUserIdSync() {
    try {
      if (window.uId) {
        this.state.userId = window.uId;
        return;
      }
      
      const savedState = getSecureItem('p10-app-state');
      if (savedState && savedState.user && savedState.user.id) {
        window.uId = savedState.user.id;
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        window.uAdministrator = savedState.user.administrator; // ADDED: Load administrator flag
        this.state.userId = savedState.user.id;
      }
    } catch (error) {
      console.error('Error in loadUserIdSync:', error);
    }
  }

  ensureUserIdSet() {
    const storedUserId = this.state.userId;
    
    if (window.uId) {
      if (this.state.userId !== window.uId) {
        this.setState({ userId: window.uId, isSignedIn: true, userDataReady: true });
      }
      return true;
    }
    
    if (storedUserId) {
      window.uId = storedUserId;
      window.uIsSignedIn = true;
      this.setState({ isSignedIn: true, userDataReady: true });
      return true;
    }
    
    try {
      const savedState = getSecureItem('p10-app-state');
      if (savedState && savedState.user && savedState.user.id) {
        window.uId = savedState.user.id;
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        window.uAdministrator = savedState.user.administrator; // ADDED: Load administrator flag
        window.uIsSignedIn = true;
        
        this.setState({ 
          userId: savedState.user.id,
          isSignedIn: true,
          userDataReady: true
        });
        return true;
      } else {
        this.setState({ userDataReady: true });
        return false;
      }
    } catch (error) {
      console.error('ReportedDime: Error restoring userId:', error);
      this.setState({ userDataReady: true });
      return false;
    }
  }

  setStateApp() {
    console.log('setStateApp: Fetching reported dimes...');
    this.setState({ isLoading: true });
    
    fetch(BLOCKED_DIMES_URL, {
      type: 'GET',
      contentType: 'application/json',
      headers: {Authorization: env.API_KEY}
    })
      .then((response) => {
        console.log('setStateApp: Response status:', response.status);
        if (!response.ok) {
          throw new Error(`Failed to fetch reported dimes: ${response.status}`);
        }
        return response.json();
      })
      .then((dimes) => {
        console.log('setStateApp: Received dimes:', dimes);
        const dimesArray = Array.isArray(dimes) ? dimes : [];
        console.log('setStateApp: Setting state with', dimesArray.length, 'dimes');
        this.setState({
          robots: dimesArray,
          isLoading: false,
          error: null
        });
      })
      .catch((error) => {
        console.error('setStateApp: Error fetching reported dimes:', error);
        this.setState({ 
          robots: [], // Ensure we have an empty array
          error: 'Failed to load reported dimes. Please try again.',
          isLoading: false 
        });
      });
  }

  handleRefresh = () => {
    this.setStateApp();
  }

  refreshAfterAction = () => {
    console.log('refreshAfterAction: Refreshing reported dimes');
    this.setStateApp();
  }
  
  componentDidMount() {
    this.ensureUserIdSet();
    // Removed onRequestRobots() - we fetch reported dimes directly
    this.setStateApp();
    
    // Add visibility change listener
    this.handleVisibilityChange = () => {
      if (!document.hidden) {
        this.ensureUserIdSet();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentWillUnmount() {
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }

  componentDidUpdate() {
    this.ensureUserIdSet();
  }

  loadUser = (data) => {
    this.setState({dime: {
      dime_id: '',
      user_id: '',
      rating_count: '',
      category: '',
      image_key: '',
      rating: ''
    }})
  }

  onRouteChange = (route) => {
    if (route === 'signout') {
      this.setState({isSignedIn: false})
    } else if (route === 'home') {
      this.setState({isSignedIn: true})
    }
    this.setState({route: route});
  }
  
  render() {
    this.ensureUserIdSet();
    
    const { isLoading, error } = this.state;
    const { searchField, onSearchChange } = this.props;
    
    const filteredRobots = this.state.robots.filter(robot => {
      return robot && robot.category && 
             robot.category.toLowerCase().includes(searchField.toLowerCase());
    });

    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        {/* Modern Top Navigation */}
        <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Container fluid style={{ maxWidth: '1800px' }}>
            <Navbar.Brand href="/reportedDime" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <img src="/images/p10.jpg" alt="P10" style={{ height: '32px', width: '32px', marginRight: '8px', borderRadius: '8px' }}/>
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>Reported Dimes</span>
            </Navbar.Brand>
            
            <div style={{ 
              flex: '1', 
              maxWidth: '900px', 
              margin: '0 20px',
              display: window.innerWidth < 992 ? 'none' : 'block'
            }}>
              <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search reported dimes..."/>
            </div>
            
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <div style={{ 
                display: window.innerWidth >= 992 ? 'none' : 'block',
                padding: '10px 0'
              }}>
                <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search reported dimes..."/>
              </div>
              
              <Nav className="ms-auto">
                <Link to={'/home'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaHome style={{ marginRight: '6px' }}/> Home
                </Link>
                <Link to={'/profile'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUser style={{ marginRight: '6px' }}/> Profile
                </Link>
                <Link to={'/dimes'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUsers style={{ marginRight: '6px' }}/> All Dimes
                </Link>
                <Link to={'/addDime'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaPlus style={{ marginRight: '6px' }}/> Add Dimes
                </Link>
                <Link to={'/signin'} className="nav-link" style={{ fontWeight: '600', color: '#e60023' }}>
                  <FaSignOutAlt style={{ marginRight: '6px' }}/> Log out
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <Container fluid style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1400px' }}>
          <div className="tc">
            {/* Header with Admin Badge */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '10px' }}>
              <h1 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', margin: 0 }}>
                Reported Dimes
              </h1>
              <span style={{
                background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                color: 'white',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '0.875rem',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <FaFlag style={{ fontSize: '12px' }}/>
                Admin
              </span>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.5rem', color: '#6b7280', margin: 0 }}>
                Review and moderate reported content
              </h2>
              <button 
                onClick={this.handleRefresh}
                style={{
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                🔄 Refresh
              </button>
            </div>
            
            {/* Error Alert */}
            {error && (
              <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                {error}
              </Alert>
            )}
            
            {/* Loading State */}
            {isLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spinner animation="border" role="status" variant="primary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                {/* No Results Message */}
                {filteredRobots.length === 0 && !isLoading && (
                  <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>🎉</div>
                    <h2 style={{ color: '#6b7280', marginBottom: '10px' }}>No reported dimes</h2>
                    <p style={{ color: '#9ca3af', marginBottom: '20px' }}>
                      {searchField ? 'Try adjusting your search' : 'All clear! No dimes have been reported.'}
                    </p>
                  </div>
                )}
                
                {/* Dimes Grid */}
                {filteredRobots.length > 0 && (
                  <BlockedDimeCardList 
                    setTest={this.setStateApp} 
                    robots={filteredRobots}
                    onActionCompleted={this.refreshAfterAction}
                  />
                )}
              </>
            )}
          </div>
        </Container>

        {/* Modern Footer */}
        <div style={{ 
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2025 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
              <Link to="/about" style={{ color: '#3b82f6', textDecoration: 'none' }}>About</Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportedDime);